import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GlobalConstantsComponent} from '../../../shared/global-constants/global-constants.component';
import { UploadFileComponent } from '../../../shared/components/upload-file/upload-file.component';
import { NgxIntlTelInputModule } from '@justin-s/ngx-intl-tel-input';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgClass, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-manage-user-file',
    templateUrl: './manage-user-file.component.html',
    styleUrls: ['./manage-user-file.component.scss'],
    standalone: true,
    imports: [MatIconModule, NgClass, NgIf, MatFormFieldModule, MatInputModule, FormsModule, NgxIntlTelInputModule, UploadFileComponent]
})
export class ManageUserFileComponent implements OnInit {

  @Input() public document:any;
  @Input() public user;
  @Output() public sendDocStatus: EventEmitter<string> = new EventEmitter<string>();

  public openRefusalPopUp:boolean=false;
  public docRefusalValue:string;
  public openReuploadPart:boolean=false;


  private rawMediaURL: string = GlobalConstantsComponent.rawMediaURL;

  constructor() { }

  ngOnInit(): void {
    if (this.document.pivot.state != 'validated') {
      this.docRefusalValue = this.document.pivot.state;
    }
    this.document.url = this.rawMediaURL +  this.document.pivot.path +  this.document.pivot.filename;
  }

  // Visualise le document
  public goToDocument(document):void {
    if(document){
      window.open(this.document.url , "_blank");
    }
  }

  public validate(docStatus):void{
    if (!docStatus) {
      docStatus = 'incorrect';
    }
    if (docStatus == 'validated') {
      this.docRefusalValue = null;
    }
    this.sendDocStatus.emit(docStatus);
    this.openRefusalPopUp = false;
  }

  public showRefusalPopUp():void {
    this.openRefusalPopUp=!this.openRefusalPopUp;
    this.docRefusalValue = null;
  }

  public showReupload() : void {
    this.openReuploadPart = !this.openReuploadPart;
  }



  // @TODO : dl au lieu d'open.
  public downloadFile(): void {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = this.document.url;
    link.download = this.user.id + '-' + this.document.key + '-' + this.document.pivot.filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

}
